function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function NewsIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1291_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1351_",
    d: "m502 0h-404c-5.522 0-10 4.477-10 10v44h-34c-5.522 0-10 4.478-10 10v54h-34c-5.523 0-10 4.478-10 10v330c0 29.775 24.225 54 54 54h404c29.775 0 54-24.225 54-54v-448c0-5.523-4.478-10-10-10zm-10 458c0 18.748-15.252 34-34 34h-362.088c7.55-9.29 12.088-21.123 12.088-34v-134.997c0-5.522-4.478-10-10-10s-10 4.478-10 10v134.997c0 18.748-15.252 34-34 34s-34-15.252-34-34v-320h24v310c0 5.522 4.478 10 10 10s10-4.478 10-10v-374h24v159.003c0 5.523 4.478 10 10 10s10-4.477 10-10v-213.003h384z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1376_",
    d: "m146 158h308c5.522 0 10-4.477 10-10v-72c0-5.522-4.478-10-10-10h-308c-5.523 0-10 4.478-10 10v72c0 5.523 4.477 10 10 10zm10-72h288v52h-288z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1459_",
    d: "m146 398h154c5.522 0 10-4.478 10-10v-192c0-5.523-4.478-10-10-10h-154c-5.523 0-10 4.477-10 10v192c0 5.522 4.477 10 10 10zm10-192h134v172h-134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1460_",
    d: "m454 186h-106c-5.522 0-10 4.477-10 10s4.478 10 10 10h106c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1476_",
    d: "m454 234h-106c-5.522 0-10 4.477-10 10s4.478 10 10 10h106c5.522 0 10-4.477 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1533_",
    d: "m454 282h-106c-5.522 0-10 4.478-10 10s4.478 10 10 10h106c5.522 0 10-4.478 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1535_",
    d: "m454 330h-106c-5.522 0-10 4.478-10 10s4.478 10 10 10h106c5.522 0 10-4.478 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1545_",
    d: "m454 378h-106c-5.522 0-10 4.478-10 10s4.478 10 10 10h106c5.522 0 10-4.478 10-10s-4.478-10-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1550_",
    d: "m146 446h308c5.522 0 10-4.478 10-10s-4.478-10-10-10h-308c-5.523 0-10 4.478-10 10s4.477 10 10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1572_",
    d: "m98.5 268c-2.63 0-5.21 1.069-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07 0 2.64 1.069 5.21 2.93 7.069 1.86 1.87 4.44 2.931 7.07 2.931s5.21-1.06 7.069-2.931c1.86-1.859 2.931-4.439 2.931-7.069s-1.07-5.21-2.931-7.07c-1.859-1.861-4.439-2.93-7.069-2.93z"
  }))));
  return output;
}
